import { TransactionReceipt } from 'nftx.js';
import {
  ReactNode,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

// When doing a permit2 approval we need to store the returned signature data in context so that the following transaction can then use it

type Permit2ContextState = {
  permit2Signature: TransactionReceipt['permit2Signature'];
};
type Permit2ContextSetState = (v: Partial<Permit2ContextState>) => void;
type Permit2ContextValue = readonly [
  Permit2ContextState,
  Permit2ContextSetState
];

const Permit2Context = createContext<Permit2ContextValue>(null as any);

export const Permit2Provider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<Permit2ContextState>({
    permit2Signature: undefined,
  });
  const updateState = useCallback((v: Partial<Permit2ContextState>) => {
    return setState((state) => ({ ...state, ...v }));
  }, []);
  const value = useMemo(
    () => [state, updateState] as const,
    [state, updateState]
  );

  return (
    <Permit2Context.Provider value={value}>{children}</Permit2Context.Provider>
  );
};

export const usePermit2 = () => {
  const v = useContext(Permit2Context);
  if (!v) {
    throw new Error('You must wrap your app in <Permit2Provider>');
  }
  return v;
};
